import { render, staticRenderFns } from "./LabelSelector.vue?vue&type=template&id=b7e2801a&scoped=true&"
import script from "./LabelSelector.vue?vue&type=script&lang=js&"
export * from "./LabelSelector.vue?vue&type=script&lang=js&"
import style0 from "./LabelSelector.vue?vue&type=style&index=0&id=b7e2801a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e2801a",
  null
  
)

export default component.exports